export const splash_messages = {
  automation: {
    msg_01: "Grab a cup of coffee—your experiment is already being prepped by our robotic team.",
    msg_02: "No pipettes, no problem. Your protocol is loading in the cloud.",
    msg_03: "While you wait, our lab bots are calibrating instruments with sub-millimeter precision.",
    msg_04: "Your reagents are being dispensed by machines that don’t get tired or distracted.",
    msg_05: "Skip the setup. Your experiment is already halfway to completion.",
    msg_06: "Think of this as your scientific autopilot—just set the destination.",
    msg_07: "Real-time data, remote control, zero commute. Welcome to the future of lab work.",
    msg_08: "Your samples are being handled with robotic consistency—no variability, no drama.",
    msg_09: "Protocols are versioned, logged, and reproducible. Reviewer-grade clarity starts here.",
    msg_10: "While you read this, your experiment is already running. That’s lab-as-a-service.",
    msg_11: "Need to rerun that assay? Just click. No cleanup, no prep, no downtime.",
    msg_12: "Your lab is now a cloud-native service. Scale experiments like you scale code.",
    msg_13: "Every run is timestamped, traceable, and reproducible. Reviewer-friendly by design.",
    msg_14: "Robots don’t forget steps. Your protocol is executed with surgical precision.",
    msg_15: "From sample prep to data upload—your experiment lifecycle is fully automated."
  },

  personalization: {
    msg_16: "Your cells, your data, your future—personalized drug discovery starts before you finish your coffee.",
    msg_17: "Human models mean human relevance. No more guessing from mice.",
    msg_18: "Every assay is tuned to your biology. That’s not magic—it’s personalized medicine at scale.",
    msg_19: "We test on human tissue, not proxies. Because your health deserves precision.",
    msg_20: "Your experiment isn’t generic. It’s tailored to your genotype, phenotype, and therapeutic goals.",
    msg_21: "Skip the animal models. Our platform runs on human biology from day one.",
    msg_22: "Drug screening, but make it personal. Your cells, your targets, your timeline.",
    msg_23: "We don’t just test drugs—we simulate outcomes on human-derived models.",
    msg_24: "Precision medicine starts with precision models. Welcome to the future of translational research.",
    msg_25: "Your cells are the lab. We just automate the rest.",
    msg_26: "From iPSC to insight—your personalized model is already running in the cloud.",
    msg_27: "We don’t guess efficacy. We simulate it on human tissue, before the first dose.",
    msg_28: "Every run is a step toward your therapeutic fingerprint. Personalized medicine, operationalized.",
    msg_29: "We don’t just accelerate discovery—we align it with your biology."
  },

  strategy: {
    msg_30: "Our AI doesn’t just analyze data—it predicts outcomes, prioritizes candidates, and guides decisions.",
    msg_31: "From cell to spreadsheet—your experiments now feed real-time business intelligence.",
    msg_32: "Every run sharpens your pipeline. Our AI ranks candidates by efficacy, safety, and ROI.",
    msg_33: "Predictive modeling meets experimental data. Your next lead compound is already being prioritized.",
    msg_34: "We don’t just run assays—we forecast success. AI-powered insights for every stakeholder.",
    msg_35: "Financial forecasts, candidate rankings, and investor updates—all powered by live experimental data.",
    msg_36: "AI connects the bench to the boardroom. More clarity, fewer surprises, happier investors.",
    msg_37: "Your pipeline just got smarter. Our models learn from every run to guide your next move.",
    msg_38: "We surface what matters: top candidates, clean data, and investor-grade insights.",
    msg_39: "From dose response to deal flow—our platform aligns science with strategy."
  }
};
